const ALLOWED_TAGS = new Set([
  "a", "b", "blockquote", "br", "code", "div", "em", "h1", "h2", "h3",
  "h4", "h5", "h6", "hr", "i", "li", "ol", "p", "pre", "s", "span",
  "strong", "sub", "sup", "table", "tbody", "td", "th", "thead", "tr", "u",
  "ul",
]);

const ALLOWED_ATTRIBUTES = new Set([
  "align", "class", "colspan", "href", "rel", "rowspan", "target", "title",
]);

function isSafeUrl(value) {
  const url = value.trim();
  return /^(?:https?:|mailto:|tel:|#)/i.test(url)
    || (url.startsWith("/") && !url.startsWith("//"));
}

function sanitizeElement(element) {
  for (const child of [...element.children]) {
    const tag = child.tagName.toLowerCase();
    if (!ALLOWED_TAGS.has(tag)) {
      child.replaceWith(...child.childNodes);
      continue;
    }

    for (const attribute of [...child.attributes]) {
      const name = attribute.name.toLowerCase();
      if (!ALLOWED_ATTRIBUTES.has(name) || name.startsWith("on")) {
        child.removeAttribute(attribute.name);
        continue;
      }

      if (name === "href" && !isSafeUrl(attribute.value)) {
        child.removeAttribute(attribute.name);
      }
    }

    if (tag === "a") {
      child.setAttribute("rel", "noopener noreferrer");
      if (child.getAttribute("target") !== "_blank") {
        child.removeAttribute("target");
      }
    }

    sanitizeElement(child);
  }
}

function fallbackSanitize(value) {
  return String(value)
    .replace(/<!--[\s\S]*?-->/g, "")
    .replace(/<(script|style|iframe|object|embed|svg|math)[^>]*>[\s\S]*?<\/\1\s*>/gi, "")
    .replace(/\son\w+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, "")
    .replace(/\s(?:href|src)\s*=\s*(["'])\s*(?:javascript|data|vbscript):[\s\S]*?\1/gi, "");
}

export function sanitizeHtml(value) {
  if (value === null || value === undefined) return "";
  if (typeof DOMParser === "undefined") return fallbackSanitize(value);

  const document = new DOMParser().parseFromString(
    `<div>${String(value)}</div>`,
    "text/html",
  );
  const root = document.body.firstElementChild;
  sanitizeElement(root);
  return root.innerHTML;
}

export const safeHtmlDirective = {
  beforeMount(element, binding) {
    element.innerHTML = sanitizeHtml(binding.value);
  },
  updated(element, binding) {
    element.innerHTML = sanitizeHtml(binding.value);
  },
};
